// bulk-selection-bar.jsx
import { Button } from "antd";
import { Icon } from "../icon/icon";
import "./bulk-selection-bar.css";

export const BulkSelectionBar = ({ left, count, onClear, onDelete, loading = false }) => {
  if (!count) return null;

  return (
    <div
      className="lf-bulk-bar"
      style={left != null ? { left } : undefined}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="lf-bulk-bar__chip">
        <span className="lf-bulk-bar__count">{count} selected</span>

        <button
          type="button"
          className="lf-bulk-bar__chip-clear"
          onClick={onClear}
          disabled={loading}
        >
          <Icon name="close" size={14} style={{ marginRight: 4, color: "var(--text-1)" }} />
        </button>
      </div>

      <div className="lf-bulk-bar__actions">
        <Button
          className="lf-bulk-bar__delete-btn"
          icon={!loading ? <Icon name="delete" style={{ marginRight: 4, color: "var(--text-1)" }} /> : null}
          onClick={onDelete}
          loading={loading}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </div>
    </div>
  );
};

export default BulkSelectionBar;